import {HeroFormsMobile} from 'components/hero-forms-mobile/hero-forms-mobile';
import {Layout} from '../../layout';
import {HeroForms} from '../hero-forms/hero-forms';
import {DialogForm} from "../dialog-form/dialog-form";
import {Button} from "../primitives/button/button";
import {
  Dialog,
  DialogHeader,
  DialogTrigger,
  DialogContent,
  DialogDescription,
  DialogTitle
} from "../dialog/dialog";
import React, {useState} from "react";

export const Hero = () => {

  const [isOpen, setOpen] = useState(false);

  const handleOpenDisclaimer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(true);
  }

  return (
    <section className="font-open-sans">
      <Layout.Container>
        <div
          className="relative h-[calc(100vh_-_144px)] screen-600:h-[calc(110vh)] screen-1200:landscape:h-[130vh] sm:landscape:h-dvh w-full rounded-[40px] py-[43px] pl-[59px] pr-[54px] bg-cover bg-center bg-[url(../public/assets/images/png/main.jpg)] screen-700:px-5 screen-700:py-2 landscape:screen-1200:py-2 screen-1220:rounded-none">
          <div className="relative z-[1] flex justify-between h-full screen-1220:flex-col">
            <div
              className="flex flex-col justify-between screen-1220:h-full screen-1220:items-center screen-1220:mt-[72px] screen-900:mt-0 landscape:screen-1200:mt-0 screen-1220:bg-gradient-to-b from-plt-black/50 to-plt-black/0 screen-1220:rounded-[20px] screen-700:px-8">
              <div className="screen-1220:hidden"/>
              <div className="max-w-[780px] screen-700:w-full">
                <h1
                  className="uppercase text-plt-white font-bold text-[60px] leading-[120%] screen-1220:text-center screen-1220:mt-6 landscape:screen-1200:landscape:text-4xl screen-950:landscape:text-3xl screen-700:text-2xl screen-700:mx-auto">
                  ЖК «Крекшино Парк»
                  <br/><span className='text-4xl'>квартиры от 4,8 млн руб.</span> <span
                  className='relative font-normal text-3xl screen-900:block screen-900:w-fit screen-900:mx-auto'>от 7,4 млн руб <span
                  className='absolute left-0 right-0 top-1/2 -translate-y-1/2 -rotate-6 block h-1 w-full bg-white'></span></span>
                </h1>
                <DialogForm title={'УЗНАЙТЕ ПОДРОБНЕЕ О СКИДКЕ'} subtitle={'СКИДКА 35% \n НА ПЕРВЫЕ 30 КВАРТИР'}
                            celtype={'getDiscountInfo'} disclaimerTitle={'Подробнее об условиях скидки'}
                            actionBtnText={'Оставить заявку'}
                            disclaimer={'ООО «СЗ «НАРАСТРОЙ-М». Проектная декларация на сайте наш.дом.рф. Скидка\n' +
                              'предоставляется ООО «СЗ «НАРАСТРОЙ-М» при покупке квартиры по ДДУ. Предложение действительно с 23.07.2025 г. на ограниченный пул квартир и может\n' +
                              'быть изменено. Предложение не распространяется при покупке квартиры в рассрочку.\n' +
                              'Не является публичной офертой. Подробности в офисе продаж ЖК «Крекшино Парк».'}>
                  <div
                    className='cursor-pointer flex flex-col justify-center items-center px-7 py-4 bg-white rounded-[20px] mt-8 w-fit screen-500:w-auto'>
                    <span className='text-2xl text-plt-secondary font-bold uppercase text-center screen-500:text-xl'>Скидка 35% только на первые 30 квартир</span>
                    <Dialog open={isOpen} onOpenChange={() => setOpen(!isOpen)}>
                      <DialogTrigger asChild onClick={(e) => handleOpenDisclaimer(e)}>
                        <Button className='text-plt-secondary text-xs uppercase py-0 leading-none' variant='ghost'>
                          Подробнее об условиях скидки
                        </Button>
                      </DialogTrigger>
                      <DialogContent>
                        <DialogHeader>
                          <DialogTitle className='font-bold text-xl font-open-sans'>
                            Условия скидки
                          </DialogTitle>
                          <DialogDescription className='sr-only'>
                            Условия скидки
                          </DialogDescription>
                        </DialogHeader>
                        <div>
                          ООО «СЗ «НАРАСТРОЙ-М». Проектная декларация на сайте наш.дом.рф. Скидка
                          предоставляется ООО «СЗ «НАРАСТРОЙ-М» при покупке квартиры по ДДУ. Предложение действительно с
                          23.07.2025 г. на ограниченный пул квартир и может
                          быть изменено. Предложение не распространяется при покупке квартиры в рассрочку.
                          Не является публичной офертой. Подробности в офисе продаж ЖК «Крекшино Парк».
                        </div>
                      </DialogContent>
                    </Dialog>
                  </div>
                </DialogForm>
                <HeroFormsMobile/>
              </div>
              <div
                className="max-w-[598px] bg-plt-secondary p-4 rounded-[21px] screen-700:rounded-[5px] screen-500:py-3 screen-950:landscape:py-2">
                <p className="text-plt-white font-semibold screen-1220:text-center screen-500:text-[10px] ">
                  Рядом лес, водоём и парк. Закрытая территория,
                  видеонаблюдение. 9 минут на автобусе до станции «Санино»
                  (МЦД-4), 20 минут от МКАД на автомобиле
                </p>
              </div>
            </div>
            <HeroForms className="screen-1220:hidden"/>
          </div>
          <div
            className="absolute top-0 left-0 right-0 bottom-0 w-full h-full rounded-[40px] bg-gradient-to-r from-plt-black/80 to-plt-black/0 screen-1220:hidden"/>
        </div>
      </Layout.Container>
    </section>
  );
};
